<template>
  <el-select v-model="tagType"
    style="vertical-align: top;"
    placeholder="请选择商品"
    @change="handleChange" filterable=""
    clearable>
    <el-option v-if="showAll"
      label="全部"
      :value="null"></el-option>
    <el-option v-for="item in list"
      :key="item.productId"
      :label="item.productName+'('+item.productNameRemark+')'"
      :value="item.productId">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'vendor-product-select',
  components: {},
  props: {
    showAll: {
      type: Boolean,
      default: false
    },
    value: {
      required: true
    },
    callback: {
      type: Function
    },
    option: {
      type: Object
    }
  },
  data () {
    return {
      list: []
    }
  },
  computed: {
    tagType: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleChange () {
      this.callback && this.callback()
    },
    fetchList () {
      this.$store.dispatch('product/getproducts', {
        payload: {
          ...this.option,
          pageNum: 1,
          pageSize: 1000,
          status: 2
        },
        success: (res) => {
          this.list = res.data.records
        },
        fail: () => {
          this.list = []
        }
      })
    }
  },
  created () { },
  mounted () {
    this.fetchList()
  }
}
</script>
<style lang="stylus" scoped></style>
